import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { getUserPaymentDetails } from 'redux/query';
import { PeriodPresenter } from 'Common';

export const SubscriptionDetailRunTime = () => {
  const { active, startsAt, endsAt } = useSelector(getUserPaymentDetails);

  return (
    <Row className="mt-2">
      <Col xs={12} sm={6} className="subscription-status-title">
        <strong>{active ? 'Laufzeit aktuelle Periode' : 'Laufzeit letzte Periode'}</strong>
      </Col>
      <Col xs={12} sm={6}>
        {active && endsAt ? <PeriodPresenter start={startsAt} end={endsAt} /> : <>endet nicht</>}
      </Col>
    </Row>
  );
};
